import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import emailjs from 'emailjs-com';
import { FaPhone, FaEnvelope, FaBuilding, FaUser } from 'react-icons/fa';
import { MdSubject } from 'react-icons/md';
import photo from '../../media/img/contact/header_contacto.jpg';
import './contactComponent.scss';

const ContactComponent = () => {
  const lineRefs = useRef([]);
  const formRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px 0px 0px',
    };

    const lineObservers = lineRefs.current.map((lineRef) => {
      if (!lineRef) return null;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('contactInfo__title-line--visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);
      observer.observe(lineRef);
      return observer;
    });

    return () => {
      lineObservers.forEach((obs) => obs?.disconnect());
    };
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        'service_52fuglj',
        'template_1zjxlhp',
        formRef.current,
        'IrxFk-gygTG-kN-rM',
      )
      .then(
        (result) => {
          console.log(result.text);
          formRef.current.reset();
          navigate('/mensaje-enviado');
        },
        (error) => {
          console.log(error.text);
          alert('Ocurrió un error. Inténtalo de nuevo.');
        },
      );
  };

  return (
    <div className="contactInfo">
      <div className="contactInfo__imageContainer">
        <img
          src={photo}
          alt="Contacto Wonderaly"
          className="contactInfo__image"
        />
      </div>
      <div className="lineatop"></div>
      <div className="lineabottom"></div>
      <div className="contactInfo__header">
        <div className="contactInfo__imagebackground-smallScream">
          <div className="contactInfo__imageContainer-smallScream">
            <img
              src={photo}
              alt="Contacto Wonderaly"
              className="contactInfo__image"
            />
          </div>
          <div className="lineatop-media991"></div>
          <div className="lineabottom-media991"></div>
        </div>
        <div className="contactInfo__text">
          <h1 className="contactInfo__title">CONTACTA CON WONDERALY</h1>
          <div
            ref={(el) => (lineRefs.current[0] = el)}
            className="contactInfo__title-line"
          />
          <p className="contactInfo__parrafo">
            Creemos en el poder del diálogo para entender a fondo lo que tu
            producción necesita. Cada proyecto es único y merece un enfoque
            personalizado basado en neuropsicología aplicada, tecnología
            avanzada y compromiso real con los resultados.
          </p>
          <p className="contactInfo__parrafo">
            Si tienes un proyecto audiovisual, una producción en marcha o
            simplemente quieres saber más sobre cómo la neuropsicología puede
            transformar tu trabajo creativo, estamos aquí para escucharte.
            Puedes llamarnos, escribirnos o rellenar el formulario y nos
            pondremos en contacto contigo.
          </p>
          <h2 className="contactInfo__subtitle">
            Estamos listos para escucharte
          </h2>
        </div>
      </div>
      <div className="contactInfo__content">
        <div className="contactInfo__form">
          <form className="form" ref={formRef} onSubmit={sendEmail}>
            <div className="form__group">
              <FaUser className="input__icon" />
              <input
                type="text"
                name="user_name"
                placeholder="Nombre"
                required
              />
            </div>
            <div className="form__group">
              <FaBuilding className="input__icon" />
              <input
                type="text"
                name="company"
                placeholder="Empresa o Productora"
                required
              />
            </div>
            <div className="form__group">
              <FaEnvelope className="input__icon" />
              <input
                type="email"
                name="user_email"
                placeholder="Email"
                required
              />
            </div>
            <div className="form__group">
              <FaPhone className="input__icon" />
              <input type="tel" name="phone" placeholder="Teléfono" />
            </div>
            <div className="form__group">
              <MdSubject className="input__icon" />
              <input type="text" name="subject" placeholder="Asunto" />
            </div>
            <div className="form__group">
              <textarea
                placeholder="Cuéntanos sobre tu proyecto"
                name="message"
                required
              ></textarea>
            </div>
            <button type="submit" className="submit__button">
              Enviar consulta
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactComponent;
